import { render, staticRenderFns } from "./DeliveryShow.vue?vue&type=template&id=9b520c46"
import script from "./DeliveryShow.vue?vue&type=script&lang=ts"
export * from "./DeliveryShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports